import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import './assets/scss/paper-dashboard.scss';
import './assets/demo/demo.css';
import 'perfect-scrollbar/css/perfect-scrollbar.css';


import App from './App';
import AuthProvider from './AuthProvider';
import { Provider } from 'react-redux';
import store from './store';
import { getClientSettings } from './store/slices/applicationData';
import { HelmetProvider } from 'react-helmet-async';
import { TitleProvider } from './contexts';
import ReactGA from "react-ga4";
// Call clientsettings api before root render
store.dispatch(getClientSettings());
// Application to Render
const app = <App />;

// Render application in DOM
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const helmetContext = {};
//Initialize GA4
ReactGA.initialize("G-PWKB0RZRVF");

root.render(
  <React.Fragment>
    <HelmetProvider context={helmetContext}>
      <BrowserRouter>
        <Provider store={store}>
            <AuthProvider>
              <App />
            </AuthProvider>
        </Provider>
      </BrowserRouter>
    </HelmetProvider>
  </React.Fragment>
);
const SendAnalytics = ()=> {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
  });
}
SendAnalytics();
